<template>
  <div class="text-center">
    <v-dialog
      v-model="value.active"
      max-width="1400"
      persistent
      scrollable
    >
    <!-- {{ value.tipoProblema }} -->
      <validation-observer
        ref="observer"
        v-slot="{ invalid }"
      >
        <form @submit.prevent="validar()">
          <v-card>
            <v-card-title class="text-h5 dialog-problema-titulo">
              <h3>
                {{
                  value.tipoProblema.CodTipoProblema
                    ? `Editando: `
                    : 'Nuevo Tipo de Problema'
                }}
              </h3>
              <span
                v-if="value.tipoProblema.NombreTipoProblema"
                class="nombre-tipo-problema"
                v-html="value.tipoProblema.NombreTipoProblema"
              />
            </v-card-title>
            <v-card-text>
              <v-row>
                <v-col class="col-12 col-lg-8">
                  <v-row>
                    <v-col class="col-12 col-sm-6">
                      <validation-provider
                        v-slot="{ errors }"
                        rules="required|max:100"
                        name="El Problema debe incluir un nombre"
                      >
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <label
                              v-bind="attrs"
                              class="grey--text"
                              v-on="on"
                            >
                              Nombre
                            </label>
                          </template>
                          <span>Nombre del Tipo de Problema</span>
                        </v-tooltip>
                        <v-text-field
                          v-model="value.tipoProblema.NombreTipoProblema"
                          :error-messages="errors"
                          color="success"
                          type="text"
                          filled
                          dense
                        />
                      </validation-provider>
                    </v-col>
                    <v-col class="col-12 col-sm-6">
                      <validation-provider
                        v-slot="{ errors }"
                        rules="required|max:50"
                        name="El Problema debe incluir un enlace"
                      >
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <label
                              v-bind="attrs"
                              class="grey--text"
                              v-on="on"
                            >
                              Enlace<span class="label-span">
                                (<b>formato:</b>
                                nuevo-tipo-problema-enlace)</span>
                            </label>
                          </template>
                          <span>URL que se asignará al Tipo de Problema. Use textos
                            sin espacios, en minúsculas y separados por guión,
                          </span>
                        </v-tooltip>
                        <v-text-field
                          v-model="value.tipoProblema.ToLink"
                          :error-messages="errors"
                          color="success"
                          type="text"
                          filled
                          dense
                        />
                      </validation-provider>
                    </v-col>
                    <v-col class="col-12 col-sm-6">
                      <validation-provider
                        v-slot="{ errors }"
                        rules="required|max:250"
                        name="El Problema debe incluir un Meta Title"
                      >
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <label
                              v-bind="attrs"
                              class="grey--text"
                              v-on="on"
                            >
                              Meta Title
                            </label>
                          </template>
                          <span>
                            Título a mostrar en pestaña (considerar SEO)</span>
                        </v-tooltip>

                        <v-text-field
                          v-model="value.tipoProblema.MetaTitle"
                          :error-messages="errors"
                          color="success"
                          type="text"
                          filled
                          dense
                        />
                      </validation-provider>
                    </v-col>
                    <v-col class="col-12 col-sm-6">
                      <validation-provider
                        v-slot="{ errors }"
                        rules="required|max:150"
                        name="Debe seleccionar un Título H1"
                      >
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <label
                              v-bind="attrs"
                              class="grey--text"
                              v-on="on"
                            >
                              Título H1
                            </label>
                          </template>
                          <span>Establece un título Principal dinámico para la estructura SEO</span>
                        </v-tooltip>
                        <v-text-field
                          v-model="value.tipoProblema.H1Titulo"
                          :error-messages="errors"
                          color="success"
                          type="text"
                          filled
                          dense
                        />
                      </validation-provider>
                    </v-col>
                    <v-col class="col-12 col-sm-6">
                      <validation-provider
                        v-slot="{ errors }"
                        rules="required|max:150"
                        name="Debe seleccionar un Título para la Sección Problemas"
                      >
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <label
                              v-bind="attrs"
                              class="grey--text"
                              v-on="on"
                            >
                              Título Sección "Problemas"
                            </label>
                          </template>
                          <span>Título verde de Problemas</span>
                        </v-tooltip>
                        <v-text-field
                          v-model="value.tipoProblema.ProblemasTitulo"
                          :error-messages="errors"
                          color="success"
                          type="text"
                          filled
                          dense
                        />
                      </validation-provider>
                    </v-col>

                    <v-col class="col-12 col-sm-6">
                      <validation-provider
                        v-slot="{ errors }"
                        rules="max:150"
                        name="Debe seleccionar un Título para la Sección Tratamiento"
                      >
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <label
                              v-bind="attrs"
                              class="grey--text"
                              v-on="on"
                            >
                              Título Sección "Tratamiento"
                            </label>
                          </template>
                          <span>Título verde de Tratamiento (sólo si incluye esta
                            sección)</span>
                        </v-tooltip>
                        <v-text-field
                          v-model="value.tipoProblema.TratamientoTitulo"
                          :error-messages="errors"
                          color="success"
                          type="text"
                          filled
                          dense
                        />
                      </validation-provider>
                    </v-col>

                    <v-col class="col-12 col-sm-6">
                      <validation-provider
                        v-slot="{ errors }"
                        rules="max:150"
                        name="Debe seleccionar un Título para la Sección Causas"
                      >
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <label
                              v-bind="attrs"
                              class="grey--text"
                              v-on="on"
                            >
                              Título Sección "Causas"
                            </label>
                          </template>
                          <span>Título verde de Causas (sólo si incluye esta
                            sección)</span>
                        </v-tooltip>
                        <v-text-field
                          v-model="value.tipoProblema.CausasTitulo"
                          :error-messages="errors"
                          color="success"
                          type="text"
                          filled
                          dense
                        />
                      </validation-provider>
                    </v-col>
                    <v-col class="col-12 col-sm-6">
                      <validation-provider
                        v-slot="{ errors }"
                        rules="required|max:150"
                        name="Debe seleccionar un Título H1"
                      >
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <label
                              v-bind="attrs"
                              class="grey--text"
                              v-on="on"
                            >
                              Título "Otros Problemas"
                            </label>
                          </template>
                          <span>Establece un título dinámico para el banner verde lateral-derecho, donde se despliegan otros problemas, antes llamado "Otros Problemas que Atendemos"</span>
                        </v-tooltip>
                        <v-text-field
                          v-model="value.tipoProblema.OtrosProblemasTitulo"
                          :error-messages="errors"
                          color="success"
                          type="text"
                          filled
                          dense
                        />
                      </validation-provider>
                    </v-col>
                    <v-col class="col-12">
                      <v-divider/>
                    </v-col>
                    <v-col
                      v-if="value.tipoProblema.Imagen"
                      class="col-12 col-sm-6"
                    >
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <label
                            v-bind="attrs"
                            class="label-img"
                            v-on="on"
                          >Imagen actual:
                            <span
                              v-html="value.tipoProblema.Imagen"
                            /></label>
                        </template>
                        <span>La imagen actual del Tipo de Poblema. Puede cambiarla
                          en el box "Cambiar Imagen"</span>
                      </v-tooltip>
                    </v-col>
                    <v-col class="col-12 col-sm-6">
                      <validation-provider
                        v-slot="{ errors }"
                        name="Archivo"
                        rules="ext:jpg,png|size:1000"
                      >
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <label
                              v-bind="attrs"
                              class="grey--text"
                              v-on="on"
                              v-html="
                                value.tipoProblema.Imagen
                                  ? 'Cambiar Imagen'
                                  : 'Subir Imagen'
                              "
                            />
                          </template>
                          <span>Cambia la imagen actual asociada al Tipo de
                            Problema</span>
                        </v-tooltip>
                        <v-file-input
                          v-model="value.imagen"
                          small-chips
                          :error-messages="errors"
                          label="Formato: jpg, png (1200x400px sugeridos)"
                          dense
                          filled
                          color="success"
                        />
                      </validation-provider>
                    </v-col>

                    <v-col class="col-12 col-sm-6">
                      <validation-provider
                        v-slot="{ errors }"
                        rules="required|max:150"
                        name="Debe seleccionar un Título para la Sección Causas"
                      >
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <label
                              v-bind="attrs"
                              class="grey--text"
                              v-on="on"
                            >
                              Atributo "ALT" de la imagen (SEO)
                            </label>
                          </template>
                          <span>Este atributo es un texto y se utiliza a describir la imagen</span>
                        </v-tooltip>
                        <v-text-field
                          v-model="value.tipoProblema.ImagenAlt"
                          :error-messages="errors"
                          color="success"
                          type="text"
                          filled
                          dense
                        />
                      </validation-provider>
                    </v-col>
                    <v-col class="col-12 col-sm-6">
                      <validation-provider
                        v-slot="{ errors }"
                        rules="required|max:150"
                        name="Debe seleccionar un Título para la Sección Causas"
                      >
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <label
                              v-bind="attrs"
                              class="grey--text"
                              v-on="on"
                            >
                              Atributo "Title" de la imagen (SEO)
                            </label>
                          </template>
                          <span>Este atributo es un texto y se utiliza a describir la imagen</span>
                        </v-tooltip>
                        <v-text-field
                          v-model="value.tipoProblema.ImagenTitle"
                          :error-messages="errors"
                          color="success"
                          type="text"
                          filled
                          dense
                        />
                      </validation-provider>
                    </v-col>
                    <v-col class="col-12">
                      <v-divider/>
                    </v-col>
                    <v-col class="col-12">
                      <h4>Descripción</h4>
                      <validation-provider
                        v-slot="{ errors }"
                        rules="required|max:7000"
                        name="Descripcion"
                      >
                        <vue-editor
                          v-model="value.tipoProblema.Descripcion"
                          :error-messages="errors"
                          :editor-toolbar="editorToolbarOptions"
                        />
                      </validation-provider>
                    </v-col>
                    <v-col class="col-12">
                      <validation-provider
                        v-slot="{ errors }"
                        rules="max:7000"
                        name="Tratamiento"
                      >
                        <h4>
                          Tratamiento
                          <span class="validation-error-title">{{
                            errors[0]
                          }}</span>
                        </h4>
                        <vue-editor
                          v-model="value.tipoProblema.Tratamiento"
                          :error-messages="errors"
                          :editor-toolbar="editorToolbarOptions"
                          :class="
                            errors.length > 0 ? 'validation-error-box' : ''
                          "
                        />
                      </validation-provider>
                    </v-col>
                    <v-col class="col-12">
                      <validation-provider
                        v-slot="{ errors }"
                        rules="max:7000"
                        name="Causas"
                      >
                        <h4>
                          Causas
                          <span class="validation-error-title">{{
                            errors[0]
                          }}</span>
                        </h4>
                        <vue-editor
                          v-model="value.tipoProblema.Causas"
                          :error-messages="errors"
                          :editor-toolbar="editorToolbarOptions"
                          :class="
                            errors.length > 0 ? 'validation-error-box' : ''
                          "
                        />
                      </validation-provider>
                    </v-col>
                    <v-col class="row-breakdown-items">
                      <v-row class="row-breakdown-items__title">
                        <v-col class="main">
                          <h3>
                            Meta Tags
                            <v-icon dark>
                              {{ $vuetify.icons.values.tagPlus }}
                            </v-icon>
                          </h3>
                          <v-btn
                            color="info"
                            :small="$vuetify.breakpoint.xs"
                            @click="abrirCrearMetaTag()"
                          >
                            <v-icon>
                              {{ $vuetify.icons.values.plusBox }}
                            </v-icon>
                            Crear Nuevo MetaTag
                          </v-btn>
                        </v-col>
                      </v-row>
                      <v-row class="row-breakdown-items__content">
                        <v-col class="col-12">
                          <v-row class="row-breakdown-items__form">
                            <v-col class="col-12 col-md-6 inputs">
                              <v-text-field
                                v-model="value.metaTagBox.name"
                                label="Name"
                                solo
                              />
                              <v-text-field
                                v-model="value.metaTagBox.content"
                                label="Content"
                                solo
                              />
                              <v-btn
                                v-if="value.metaTagModoCreacion"
                                color="info"
                                @click="crearMetaTag()"
                              >
                                Crear
                              </v-btn>
                              <v-btn
                                v-else
                                @click="editarMetaTag()"
                              >
                                editar
                              </v-btn>
                            </v-col>
                            <v-col class="col-12 col-md-6 alerts">
                              <div class="alert-main">
                                <v-alert
                                  v-if="showMsgMetaTag"
                                  dense
                                  text
                                  :type="typeMsgMetaTag"
                                >
                                  <span v-html="msgMetaTag" />
                                </v-alert>
                              </div>
                            </v-col>
                          </v-row>
                          <v-row
                            class="row-breakdown-items__table justify-center"
                          >
                            <v-col class="col-12">
                              <div class="divider" />
                            </v-col>
                            <v-col
                              v-if="
                                value.tipoProblema.MetaTags != undefined &&
                                  value.tipoProblema.MetaTags.length > 0
                              "
                              class="col-12 col-md-9 mt-5 mb-5 table-main"
                            >
                              <v-simple-table dense>
                                <template v-slot:default>
                                  <thead>
                                    <tr>
                                      <th class="text-left">
                                        Name
                                      </th>
                                      <th class="text-left">
                                        Content
                                      </th>
                                      <th>
                                        Editar
                                      </th>
                                      <th>
                                        Eliminar
                                      </th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr
                                      v-for="(item, i) in value.tipoProblema.MetaTags"
                                      :key="i"
                                    >
                                      <td>{{ item.Name }}</td>
                                      <td>{{ item.Content }}</td>
                                      <td class="td-btn">
                                        <v-btn
                                          color="info"
                                          small
                                          @click="
                                            abrirEditarMetaTag(
                                              value.tipoProblema.MetaTags.indexOf(
                                                item
                                              )
                                            )
                                          "
                                        >
                                          <v-icon>{{ $vuetify.icons.values.menuDown }}</v-icon>
                                        </v-btn>
                                      </td>
                                      <td class="td-btn">
                                        <v-btn
                                          color="info"
                                          small
                                          @click="
                                            eliminarMetaTag(
                                              value.tipoProblema.MetaTags.indexOf(
                                                item
                                              )
                                            )
                                          "
                                        >
                                          <v-icon>{{ $vuetify.icons.values.delete }}</v-icon>
                                        </v-btn>
                                      </td>
                                    </tr>
                                  </tbody>
                                </template>
                              </v-simple-table>
                            </v-col>
                            <v-col
                              v-else
                              class="no-breakdown-items"
                            >
                              Aún no has añadido metatags a este tipo de problema
                            </v-col>
                          </v-row>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-col>

                <v-col class="col-12 col-lg-4">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <h4
                        v-bind="attrs"
                        class="grey--text"
                        v-on="on"
                      >
                        Problemas Asociados
                      </h4>
                    </template>
                    <span>Problemas asociados a este tipo (escoja al menos
                      uno)</span>
                  </v-tooltip>
                  <div class="chk-problemas__main">
                    <v-checkbox
                      v-for="(item, i) in value.problemas"
                      :key="i"
                      v-model="item.checked"
                      :label="item.NombreProblema"
                      color="success"
                      hide-details
                    />
                  </div>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions>
              <v-spacer />
              <v-btn
                color="green darken-1"
                text
                @click="cerrar()"
              >
                Cerrar
              </v-btn>
              <v-btn
                color="success"
                default
                type="submit"
                :disabled="invalid"
                :loading="value.loader"
              >
                Grabar
              </v-btn>
            </v-card-actions>
          </v-card>
        </form>
      </validation-observer>
    </v-dialog>
  </div>
</template>

<script>
// import Vue from 'vue'
  import { VueEditor } from 'vue2-editor'
  export default {
    name: 'ShowDialogTipoProblema',
    components: {
      VueEditor,
    },
    props: {
      value: {
        active: {
          type: Boolean,
          default: false,
        },
        tipoProblema: {
          type: Object,
          default: false,
        },
        problemas: {
          type: Array,
          default: false,
        },
        imagen: {
          type: Object,
          default: false,
        },
        loader: {
          type: Boolean,
          default: false,
        },
        metaTagBox: {
          type: Object,
          default: {},
          name: {
            type: String,
            default: '',
          },
          content: {
            type: String,
            default: '',
          },
        },
        metaTagModoCreacion: {
          type: Boolean,
          default: true,
        },
        default: null,
        type: Object,
      },
    },
    data () {
      return {
        editorToolbarOptions: require('@/data/editorToolbarOptions.json'),
        showMsgMetaTag: false,
      }
    },
    watch: {
      'value.active': function (value) {
        requestAnimationFrame(() => {
          // Reseteamos vee al cerrar dialog
          this.$refs.observer.reset()
        })
      },
    },
    methods: {
      validar () {
        this.$emit('procesar', this.value)
      },
      cerrar () {
        this.$emit('cerrar')
      },
      abrirEditarMetaTag (index) {
        console.log(`abrirEditar MetaTag ${index}`)
        this.metaTagIdEditar = index
        this.value.metaTagModoCreacion = false
        this.value.metaTagBox.name = this.value.tipoProblema.MetaTags[index].Name
        this.value.metaTagBox.content = this.value.tipoProblema.MetaTags[index].Content
      },
      abrirCrearMetaTag () {
        this.value.metaTagModoCreacion = true
        this.value.metaTagBox = {
          name: '',
          content: '',
        }
      },
      crearMetaTag () {
        const element = {
          Name: this.value.metaTagBox.name,
          Content: this.value.metaTagBox.content,
        }
        if (!this.value.tipoProblema.MetaTags) this.value.tipoProblema.MetaTags = []
        this.value.tipoProblema.MetaTags.unshift(element)
        this.limpiaMetaTagBox()
        this.showAlertMetaTag(
          'Registro creado. Debe grabar para guardar cambios definitivamente',
          'success',
        )
      },
      async editarMetaTag () {
        this.value.tipoProblema.MetaTags[
          this.metaTagIdEditar
        ].Content = this.value.metaTagBox.content
        this.value.tipoProblema.MetaTags[
          this.metaTagIdEditar
        ].Name = this.value.metaTagBox.name
        this.limpiaMetaTagBox()
        this.showAlertMetaTag(
          'Registro editado. Debe grabar para guardar cambios definitivamente',
          'success',
        )
      },
      eliminarMetaTag (index) {
        if (confirm('¿Estás seguro/a que deseas eliminar este MetaTag?')) {
          this.value.tipoProblema.MetaTags.splice(index, 1)
          this.limpiaMetaTagBox()
          if (this.value.tipoProblema.MetaTags.length === 0) {
            this.value.tipoProblema.MetaTags = 0
          }
          this.showAlertMetaTag(
            'Registro eliminado. Debe grabar para guardar cambios definitivamente',
            'warning',
          )
        }
      },
      showAlertMetaTag (msg, type) {
        this.msgMetaTag = msg
        this.typeMsgMetaTag = type
        this.showMsgMetaTag = true
        setTimeout(() => {
          this.msgMetaTag = ''
          this.typeMsgMetaTag = ''
          this.showMsgMetaTag = false
        }, 6000)
      },
      limpiaMetaTagBox () {
        this.value.metaTagModoCreacion = true
        this.value.metaTagBox.name = ''
        this.value.metaTagBox.content = ''
        this.metaTagIdEditar = false
      },
    },
  }
</script>

<style lang="sass" scoped>
@import '@/sass/variables2'
.pre-formatted
  white-space: pre

.validation-error-box
  border: 1px solid #ff6668

.validation-error-title
  color: #ff6668

.ql-editor
  height: 200px !important

.chk-problemas__main
  overflow-y: scroll
  height: 1220px

.label-img
  color: #9e9e9e
  span
    color: $orange
.v-card
  .dialog-problema-titulo
    h3
      color: $green !important
      display: inline
    span
      color: #9e9e9e
      text-transform: capitalize
      font-weight: bold
.label-span
    font-size: 13px !important
    color: $green
.row-breakdown-items
  .row-breakdown-items__title
    .main
      background: #5bc0de
      color: white
      display: flex
      @media (max-width: 1264px)
        flex-direction: row
      @media (max-width: 460px)
        flex-direction: column
        justify-content: center
      h3
        display: flex
        justify-content: center
        align-items: center
        .v-icon
          margin-left: 5px !important
      .v-btn
        margin-right: 0px !important
  .row-breakdown-items__content
    background: $lightblack4
    .row-breakdown-items__form
      .inputs
        display: flex
        flex-direction: column
        justify-content: space-between
        padding: 20px
        .v-btn
          margin-right: 0px
          width: 200px
      .alerts
        display: flex
        flex-direction: column
        justify-content: space-between
        padding: 20px
        .alert-main
          height: 50px
        span
          font-weight: 300 !important
          font-size: 14px
        .v-btn
          margin-right: 0px
          width: 200px
    .row-breakdown-items__table
      .td-btn
        width: 50px
      .divider
        width: 100%
        height: 2px
        background: $lightblack3
      .table-main
        background: $white
      .no-breakdown-items
        text-align: center
        padding: 20px
        background: $lightblack4
</style>
